import { render, staticRenderFns } from "./TestPaperZz.vue?vue&type=template&id=2e93cbee&scoped=true"
import script from "./TestPaperZz.vue?vue&type=script&lang=js"
export * from "./TestPaperZz.vue?vue&type=script&lang=js"
import style0 from "./TestPaperZz.vue?vue&type=style&index=0&id=2e93cbee&prod&lang=less"
import style1 from "./TestPaperZz.vue?vue&type=style&index=1&id=2e93cbee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93cbee",
  null
  
)

export default component.exports